import React from 'react';
import styled from 'styled-components';
import Cross from '@splunk/react-icons/Cross';
import Message from '../Message';

const MsgContainer = styled.div`
    display: inline-block;
    width: 95%;
    height: 200px;
    position: relative;
`;

const MsgClose = styled.div`
    float: right;
`;

export interface GalleryMessageProps {
    error?: string;
    warning?: string;
    onClose?: () => void;
}

export const GalleryMessage = ({
    error,
    warning,
    onClose,
}: GalleryMessageProps) => {
    if (!error && !warning) {
        return null;
    }

    const type = error ? 'error' : 'warning';
    const msg = typeof error === 'string' && error !== '' ? error : warning;

    return (
        <MsgContainer>
            <Message level={type} message={msg} />
            {onClose && (
                <MsgClose onClick={onClose}>
                    <Cross width="12px" height="12px" />
                </MsgClose>
            )}
        </MsgContainer>
    );
};
